import 'utils/localization/i18n';

import Router from 'utils/routing/router';

const App = () => {
  return <Router />;
};

export default App;
